import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { SaveSvg } from './svgs';

export const IconSave: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={SaveSvg} viewBox="0 0 16 16" {...props} />;
};
